export const CREATE_CENTRE_BOOKING_REQUEST = "CREATE_CENTRE_BOOKING_REQUEST";
export const CREATE_CENTRE_BOOKING_SUCCESS = "CREATE_CENTRE_BOOKING_SUCCESS";
export const CREATE_CENTRE_BOOKING_FAILURE = "CREATE_CENTRE_BOOKING_FAILURE";

export const GET_CENTRE_BOOKINGS_REQUEST = "GET_CENTRE_BOOKINGS_REQUEST";
export const GET_CENTRE_BOOKINGS_SUCCESS = "GET_CENTRE_BOOKINGS_SUCCESS";
export const GET_CENTRE_BOOKINGS_FAILURE = "GET_CENTRE_BOOKINGS_FAILURE";

export const RESET_CENTRE_BOOKING_STATE = "RESET_CENTRE_BOOKING_STATE";


